// @flow

import React from 'react';

import notification from 'antd/lib/notification';

import { inspectionGibddApi } from '../../../../../lib/api';
import type { InspectionGibdd } from '../../../../../lib/types';

import Filter from '../../../../services/inspectionsGibdd/Filter';
import { INSPECTION_GIBDD_COLUMNS } from '../../../../services/inspectionsGibdd';

import { ListTable } from '../../../lib';

export default class extends ListTable<InspectionGibdd> {
  fetch = async (page: number = 1) => {
    const params = super.fetch(page);
    try {
      const data = await inspectionGibddApi.fetchInspectionsGibdd(params);
      const totalSum = await inspectionGibddApi.getTotalSum(params);
      this.setState({ ...data, totalSum, loading: false, page });
    } catch (error) {
      notification.error({
        message: 'Ошибка',
        description: error.message
      });
    }
  };

  render() {
    return (
      <>
        {super.renderFilter(Filter)}
        {super.renderTable(INSPECTION_GIBDD_COLUMNS)}
      </>
    );
  }
}
